import { render, staticRenderFns } from "./IconKuper.vue?vue&type=template&id=50aeeb93&"
import script from "./IconKuper.vue?vue&type=script&lang=js&"
export * from "./IconKuper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports